import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Avatar,
  Rating,
  Typography,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const DisplayReview = ({ data, openModal, closeModal }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };

  return (
    <Dialog
      open={openModal}
      onClose={closeModal}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          width: { xs: "90%", sm: "50%", md: "25%" },
          maxHeight: { md: "70%", xs: "80%", sm: "60%" },
          backgroundColor: "#1a1a1a",
          border: "1px solid #2a2a2a",
          color: "#fff",
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" flex={1} justifyContent="flex-end">
          <IconButton onClick={closeModal} sx={{ color: "#666", "&:hover": { color: "#fff" } }}>
            <ClearIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ padding: "24px 30px 32px" }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <Rating
            name="simple-controlled"
            value={data.rating}
            readOnly
            size="large"
            sx={{ "& .MuiRating-iconFilled": { color: "#FFC001" } }}
          />
        </Box>
        <Box display="flex" justifyContent="center" mb={2}>
          <Avatar
            alt="User Avatar"
            src={data.user.avatar_url}
            sx={{ width: 64, height: 64 }}
          />
        </Box>
        <Box display="flex" justifyContent="center" mb={1}>
          <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#fff" }}>
            {data.user.full_name}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" mb={1.5}>
          <Typography sx={{ fontSize: "13px", color: "#555" }}>
            {data.reviewable.name} · {formatDate(data.created_at)}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <Typography sx={{ fontSize: "14px", color: "#aaa", lineHeight: 1.8, textAlign: "center", wordBreak: "break-word" }}>
            {data.content}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DisplayReview;
